import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignUserRole } from '../services/userRbac';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';

interface AssignRoleParams {
    userId: string;
    roleId: string;
}

export const useAssignRoleMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, AssignRoleParams>({
        mutationFn: ({ userId, roleId }) => assignUserRole(userId, roleId),
        onSuccess: (_, { userId }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.roles(userId) });
            queryClient.invalidateQueries({ queryKey: userKeys.detail(userId) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
